// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2UGmV","label":"Labeled_label__1icAZ","divider":"Labeled_divider__8rfR5"};